import { Badge } from '@/components/ui/badge';
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Sparkles } from 'lucide-react';

interface ShopInsuranceHeaderProps {
  isLoading: boolean;
  error: QuoteError | null;
}

export function ShopInsuranceHeader({ isLoading, error }: ShopInsuranceHeaderProps) {
  const description = isLoading
    ? 'Loading available insurance quotes...'
    : error !== null
      ? 'No quotes available'
      : 'Compare available insurance quotes';

  return (
    <DialogHeader className="mb-6 h-max">
      <div className="text-left">
        <DialogTitle className="text-primary-dark flex items-center gap-2 text-xl font-semibold md:text-2xl">
          Explore Coverage Options
          <Badge
            variant="primary"
            className="flex items-center gap-1 px-2 py-0.5 text-xs uppercase"
          >
            <Sparkles className="h-3 w-3" />
            BETA
          </Badge>
        </DialogTitle>
        <DialogDescription className="text-sm text-gray-700 md:text-base">
          {description}
        </DialogDescription>
      </div>
      <div className="mt-4 border-b border-gray-200"></div>
    </DialogHeader>
  );
}
